import React, { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  BUTTON_VARIANT_SECONDARY,
  Button,
  GRID_VARIANT_SMALL,
  Grid,
  GridCell,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  TEXT_VARIANT_BOLD,
  Text,
} from 'mailup-web-components'

import { editableFiltersTypes } from 'Pages/RecipientsList/model'
import {
  modalFilterDetailsCancel,
  modalFilterDetailsEdit,
} from 'Pages/RecipientsList/recoil/callbacks/modals'
import { modalFilterDetailsState } from 'Pages/RecipientsList/recoil/state/modals'

const ModalFilterDetails: FC = () => {
  const intl = useIntl()
  const { show, id, name, description, type } = useRecoilValue(
    modalFilterDetailsState,
  )

  const handleCancelClick = useRecoilCallback(modalFilterDetailsCancel, [])

  const handleEditClick = useRecoilCallback(modalFilterDetailsEdit, [])

  return (
    <Modal
      show={show}
      onClose={handleCancelClick}
      closeOnOverlayClick
      data-mu-test="modal-filter-details"
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.SearchRecipients.EditFilterFilterTitle',
        })}
      />

      <ModalBody>
        <Grid cols={4} variant={GRID_VARIANT_SMALL}>
          <GridCell span={1}>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterType',
              })}
            </Text>
          </GridCell>
          <GridCell span={3}>{type}</GridCell>

          <GridCell span={1}>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterName',
              })}
            </Text>
          </GridCell>
          <GridCell span={3}>
            {id} - {name}
          </GridCell>

          <GridCell span={1}>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterConditions',
              })}
            </Text>
          </GridCell>
          <GridCell span={3}>{description}</GridCell>
        </Grid>
      </ModalBody>

      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          onClick={handleCancelClick}
          data-mu-test="modal-filter-details__cancel"
        >
          {intl.formatMessage({
            id: 'Load.SearchRecipients.EditFilterCloseButton',
          })}
        </Button>
        {editableFiltersTypes.includes(type) && (
          <Button
            kind={BUTTON_VARIANT_SECONDARY}
            onClick={handleEditClick}
            data-mu-test="modal-filter-details__edit"
          >
            {intl.formatMessage({
              id: 'Load.SearchRecipients.EditFilterEditButton',
            })}
          </Button>
        )}
      </ModalFoot>
    </Modal>
  )
}

export default ModalFilterDetails
